import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

import Home from '~cp/Public/Home.vue'
import AcceptMarketplaces from '~user-pages/UserSettings/Marketplaces/AcceptMarketplaces'
import Authentication from '~cp/Authentication/Authentication.vue'
import AuthenticationRoutes from './modules/authentication-routes.js'

import Public from '~cp/Public/Public.vue'
import PublicRoutes from './modules/public-routes.js'

import UserPanel from '~cp/UserPanel/UserPanel.vue'
import UserPanelRoutes from './modules/user-panel-routes.js'

import AdminPanelRoutes from './modules/admin-panel-routes.js'

import NotFoundPage from '~cp/NotFoundPage/NotFoundPage.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/auth',
            component: Authentication,
            children: [
                ...AuthenticationRoutes
            ]
        },
        {
            path: '/public',
            component: Public,
            children: [
                ...PublicRoutes
            ]
        },
        {
            path: '/user-panel',
            beforeEnter: (to, from, next) => {
                if (to.matched.some(record => record.meta.requiresAuth)) {
                    if (!store.getters.authorization && !localStorage.getItem('userToken')) {
                        next({
                            name: 'login',
                            query: { redirect: to.fullPath }
                        })
                    } else {
                        next()
                    }
                } else {
                    next()
                }
            },
            component: UserPanel,
            meta: {
                requiresAuth: true,
                breadcrumb: {
                    text: 'Home'
                }
            },
            children: [
                ...UserPanelRoutes
            ]
        },
        {
            path: '/admin-panel',
            name: 'AdminPanel',
            beforeEnter: (to, from, next) => {
                if (to.matched.some(record => record.meta.requiresAuth)) {
                    if (!store.getters.authorization && !localStorage.getItem('userToken') || !store.getters.isSuperAdmin) {
                        next({
                            name: 'AdminAuth',
                            query: { redirect: to.fullPath }
                        })
                    } else {
                        next()
                    }
                } else {
                    next()
                } 
            },
            component: () => import('~cp/AdminPanel/AdminPanel.vue'),
            meta: {
                requiresAuth: true,
            },
            children: [
                ...AdminPanelRoutes
            ]
        },
        {
            path: '/marketplace/accept/*',
            component: AcceptMarketplaces,
        },
        {
            path: '*',
            name: 'not-found-page',
            component: NotFoundPage
        }
    ],
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
})



// WEBPACK FOOTER //
// ./src/router/index.js